import axios from "axios";
import { rollUpMember, upPubListEntry , userAssociation, upGroupPubListEntry, upStatusDataItem, upSubStatusDataItem, upDatCatSizeDataItem, upSiteEntry, upDatModSizeDataItem, upDatModPackageDataItem, ATOLDeadlines} from "./interfaces";

interface userSearchParams{
    searchFor:string
    userType:string
    field:string
    site:string
}

export async function getUserList(params:userSearchParams){
    
    var queryString = "?";

    if (params.site!=""){
        queryString+="site=" + params.site + "&"
    }
    if (params.userType!=""){
        queryString+="userType=" + params.userType + "&"
    }
    if (params.field!=""){
        queryString+="searchField=" + params.field + "&"
    }
    if (params.searchFor!=""){
        queryString+="searchValue=" + encodeURIComponent(params.searchFor) + "&"
    }
    if (queryString.slice(-1) == "&") {
        queryString = queryString.slice(0, -1);
    }

    const url = "/api/GetUserList"+ queryString;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getAssociationsForUser(username:string){
    
    const url = "/api/GetAssociationsForUser?username="+ username;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function addUserAssociation(association:userAssociation){
    const url = "/api/AddAssociation";
    try{
      const jsonField = JSON.stringify(association);
      console.log(jsonField);
      const header = {
        headers: {
            'Content-Type': 'application/json'
        }
      }
      const response = await axios.post(url, jsonField, header);
      if (response.status!==200) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        //const data = await response.();
        return "200";
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
  }

  export async function removeUserAssociation(association:userAssociation){
    const url = "/api/RemoveAssociation";
    try{
    const jsonField = JSON.stringify(association);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
  }

export async function deleteUser(username:string){
    const url = "/api/DeleteUser";
    try{
      const jsonField = JSON.stringify(username);
      console.log(jsonField);
      const header = {
        headers: {
            'Content-Type': 'application/json'
        }
      }
      const response = await axios.post(url, jsonField, header);
      if (response.status!==200) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        //const data = await response.();
        return "200";
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
  }

  export async function getAllRollUpGroups(){
  
  var url = "/api/GetAllRollUpGroups";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function addUserGroup(newGroup:rollUpMember){
    const url = "/api/AddUserGroup";
    try{
      const jsonField = JSON.stringify(newGroup);
      console.log(jsonField);
      const header = {
        headers: {
            'Content-Type': 'application/json'
        }
      }
      const response = await axios.post(url, jsonField, header);
      if (response.status!==200) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        //const data = await response.();
        return "200";
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
  }

  export async function removeUserGroup(group:rollUpMember){
    const url = "/api/RemoveUserGroup";
    try{
    const jsonField = JSON.stringify(group);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
  }

  interface pwChage{
    username:string
    password:string
  }

  export async function changePassword(username:string, password:string){
    const url = "/api/ChangePassword";
    try{
      const content:pwChage = {username:username, password:password};
    //const jsonField = JSON.stringify({username:username, password:password});
    //console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, content, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
  }


  export async function trustUser(account:string, security:string){
    const url = "/api/TrustUser?account="+account+"&security="+security;
    try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await fetch(url);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
  }

  export async function unTrustUser(account:string){
    const url = "/api/UntrustUser?account="+account;
    try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await fetch(url);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
  }



  export async function getNextPubNum(){
    
    const url = "/api/GetNextPubNum";
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function getPubList(archive:number=0){
    
    var url = "/api/GetAdminPubList";
    if (archive==1){
      url+="?archive=1";
    }
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function savePub(fields:upPubListEntry){ 

  console.log(fields);
  const formData: Record<string, any> = {};
  formData["oPubNum"] = fields.oPubNum;
  formData["oPubName"] = fields.oPubName;
  formData["pubNum"] = fields.pubNum;
  formData["pubName"] = fields.pubName;
  formData["tmpChar"] = fields.tmpChar;
  formData["tmpInt1"] = fields.tmpInt1;
  formData["purgeDelay"] = fields.purgeDelay;
  formData["killDelay"] = fields.killDelay;
  formData["killPath"] = fields.killPath;
  formData["opiPath"] = fields.opiPath;
  formData["opiPathA"] = fields.opiPathA;
  formData["archiveName"] = fields.archiveName;
  formData["autoToning"] = fields.autoToning;
  formData["isArchivePub"]=fields.isArchivePub;
  formData["isActivePub"]=fields.isActivePub;
  //Duplicate Pub
  formData["DuplicatePub"] = "";
  //AutoIncremement

  const url = "/api/savePub";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function deletePub(pubNum:string, pubName:string){
  const url = "/api/deletePublication?pubNum=" + pubNum + "&pubName=" + pubName;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function getGroupPubList(archive:number=0){
    
    var url = "/api/GetAdminGroupPubList";
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function saveGroupPub(fields:upGroupPubListEntry){ 

  console.log(fields);
  const formData: Record<string, any> = {};
  formData["oPubNum"] = fields.oPubNum;
  formData["oName"] = fields.oName;
  formData["oUserType"]=fields.oUserType
  formData["pubNum"] = fields.pubNum.toString();
  formData["name"] = fields.name;
  formData["tmpChar"] = fields.tmpChar;
  formData["tmpInt"] = fields.tmpInt;
  formData["userType"]=fields.userType;
  formData["groupNum"]=fields.groupNum.toString();
  formData["groupNumCode"]=fields.groupNumCode;

  const url = "/api/saveGroupPub";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function deleteGroupPub(pubNum:string, name:string, userType:string){
  const url = "/api/deletePublication?pubNum=" + pubNum + "&pubName=" + name + "&userType="+userType;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function saveStatus(fields:upStatusDataItem){ 

  console.log(fields);
  const formData: Record<string, any> = {};
  formData["oStatus"] = fields.oStatus;
  formData["oDisplayOrder"] = fields.oDisplayOrder;
  formData["oUserType"] = fields.oUserType;
  formData["adminOnly"] = fields.adminOnly;
  formData["autoEps"] = fields.autoEps;
  formData["atolView"] = fields.atolView;
  formData["color"] = fields.color;
  formData["displayOrder"] = fields.displayOrder;
  formData["epsFail"] = fields.epsFail;
  formData["epsPreflight"] = fields.epsPreflight;
  formData["epsSuccess"] = fields.epsSuccess;
  formData["status"] = fields.status;
  formData["tempChar1"] = fields.tempChar1;
  formData["teemp"] = fields.tempInt;
  formData["userType"] = fields.userType;
  formData["workflowLevel"] = fields.workflowLevel;
  const url = "/api/saveStatus";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}


export async function deleteStatus(status:string, displayOrder:string, userType:string){
  const url = "/api/deleteStatus?status=" + status + "&displayOrder=" + displayOrder + "&userType="+userType;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function saveSubStatus(fields:upSubStatusDataItem){ 

  console.log(fields);
  const formData: Record<string, any> = {};

  formData["oStatus"] = fields.oStatus;
  formData["oFieldString"] = fields.oFieldString;
  formData["oStat2Field"] = fields.oStat2Field;
  formData["Status"] = fields.Status;
  formData["Stat2Field"] = fields.Stat2Field;
  formData["FieldString"] = fields.FieldString;
  formData["OperationID"] = fields.OperationID;
  const url = "/api/saveSubStatus";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function deleteSubStatus(status:string, stat2Field:string, fieldString:string){
  const url = "/api/deleteSubStatus?status=" + status + "&stat2Field=" + stat2Field + "&fieldString="+fieldString;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

  export async function getDatCatSizeList(){
    
    var url = "/api/GetDatCatSizeList";
    
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }
  export async function getDatModSizeList(site:string, colType:string){
    
    var url = "/api/GetDatModSizeList?site="+site+"&category="+colType;
    
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


export async function saveDatCatSize(fields:upDatCatSizeDataItem){ 

  console.log(fields);
  const formData: Record<string, any> = {};
  const url = "/api/saveDatCatSize";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function saveDatModSize(fields:upDatModSizeDataItem){ 

  console.log(fields);
  const formData: Record<string, any> = {};
  const url = "/api/saveDatModSize";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function deleteDatCatSize(category:string, site:string){
  const url = "/api/deleteDatCatSize?category=" + category + "&site=" + site;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
  }
}


export async function deleteDatModSize(category:string, site:string, size:string){
  const url = "/api/deleteDatCatSize?category=" + category + "&site=" + site + "&strIn="+size;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
  }
}


export async function getAdminSiteList(){
    
    var url = "/api/GetAdminSiteList";
    
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

export async function saveSite(fields:upSiteEntry){ 

  console.log(fields);
  const formData: Record<string, any> = {};
  const url = "/api/saveSite";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}


export async function deleteSite(code:string){
  const url = "/api/deleteSite?code=" + code;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
  }
}


export async function getModPackageList(site:string){
    
    var url = "/api/GetModPackageList?site="+site;
    
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

export async function saveDatPackage(fields:upDatModPackageDataItem){ 

  console.log(fields);
  const formData: Record<string, any> = {};
  const url = "/api/saveDatPackage";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}


export async function deleteDatPackage(category:string, site:string, sizeIn:string,sizeOut:string, modID:number){
  const url = "/api/deleteDatPackage?category=" + category + "&site=" + site + "&strIn="+sizeIn+ "&strOut="+sizeOut+ "&modID="+modID;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
  }
}


export async function getModColTypes(site:string){
    
    var url = "/api/GetModColTypes?site="+site;
    
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


export async function getDeadlineList(pubs:string){
    
    var url = "/api/GetDeadlineList?pubs="+pubs;
    
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function saveDeadline(changes:ATOLDeadlines[]){ 

  console.log(changes);
  const url = "/api/saveDeadline";
  try{
    const jsonField = JSON.stringify(changes);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }

   
}

export async function deleteSingleDeadline(deadline:ATOLDeadlines){
  const url = "/api/deleteSingleDeadline?pubName=" + deadline.pubName + "&setting=" + deadline.setting + "&temp1="+deadline.temp1;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function deletePubDeadline(pubName:string){
  const url = "/api/deletePubDeadline?pubName=" + pubName;
  try{
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.delete(url, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}